import type { Animation } from '@ionic/core';

export function dropdownCloseAnimation(_element: HTMLElement): Animation | undefined {
  return undefined;
}
